import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

interface IRichTextInputProps {
  id: any
  text?: string
  value?: any
  onChange?: any
  errorKey?: any
  className?: any
  disabled?: boolean
  selectRef?: any
  errors?: any
  isRequired?: boolean
}

const RichTextInput: FC<IRichTextInputProps> = (props: IRichTextInputProps) => {
  const { id, text = '', errors, selectRef, value, disabled, className, onChange, isRequired = true } = props
  const { t } = useTranslation()

  const modules = {
    toolbar: [
      [{ font: [] }, { size: [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ color: [] }, { background: [] }],
      [{ script: 'super' }, { script: 'sub' }],
      [{ header: '1' }, { header: '2' }, 'blockquote', 'code-block'],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
      ['direction', { align: [] }],
      ['link', 'formula'],
      ['clean'],
    ],
  }

  return (
    <div className={className}>
      <div className="form-group">
        {text && (
          <label htmlFor={id} className="">
            {t(text)}
            {isRequired && <strong className="text-danger">*</strong>}
          </label>
        )}

        <ReactQuill id={id} ref={selectRef} modules={modules} theme="snow" value={value} onChange={onChange} className="w-100" readOnly={disabled} />
        {errors && errors[id] && <div className="invalid-feedback">{errors[id].message}</div>}
      </div>
    </div>
  )
}

export default RichTextInput
